<template>
  <div class="pie-wrap position-relative">

    <svg class="pie-vector" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" :height="pieH">
      <defs>
        <linearGradient :id="uuid + 'bgGrad'">
          <stop offset="0%" :stop-color="gradMidPt"/>
          <stop offset="100%" :stop-color="stroke[0]" stop-opacity="0.8"/>
        </linearGradient>
        <linearGradient :id="uuid + 'strokeGrad'" gradientTransform="rotate(-115, 0.5, 0.5)">
          <stop offset="0%" :stop-color="stroke[1]"/>
          <stop offset="100%" :stop-color="stroke[0]"/>
        </linearGradient>
      </defs>

      <circle
        cx="100"
        cy="100"
        r="100"
        :fill="'url(#' + uuid + 'bgGrad)'"
        fill-opacity="0.55"
        transform="rotate(-90 100 100)"
        stroke-width="18"
        stroke-opacity="0.9"
        stroke-dasharray="630"
        :stroke-dashoffset="630 - (num / 100) * 630"
        :stroke="'url(#' + uuid + 'strokeGrad)'"
      />
    </svg>

    <percentage
      :num="num"
      :label="label.title"
      :label-pos="label.pos"
      :align="label.align"
      class="position-absolute absolute-center"
      :font-size="fontSize"
      :ind-override="indOverride"
    />
  </div>
</template>

<script>
  import { gradPtColor } from '@/lib/funcs'
  import GraphFragMixin from '@/components/report/mixins/GraphFragMixin'

  export default {
    name: 'PieFragment',
    mixins: [ GraphFragMixin ],
    props: {
      stroke: { type: Array, default () { return [ this.accent, this.mainColor ] } }
    },
    data () {
      return { pieH: null }
    },
    computed: {
      gradMidPt () {
        return gradPtColor( ...this.stroke, 0.5 )
      }
    },
    mounted () {
      if ( this.isIE ) {
        setTimeout( () => {
          this.pieH = this.$el.clientWidth + 'px'
        }, 250 )
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../assets/scss/global/the_goods";

  .pie-wrap {
    flex   : 1 0 0;
    margin : 0 viewport-scale(5);

    @include screen-md-lg-xl {
      margin : 0 rem(50);
    }
  }

  .pie-vector {
    max-width : 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/PieFragment.vue